import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/app/store/auth.store'
import { useDefaultLayout } from './useDefaultLayout'

export function useSidebar() {
  const route = useRoute()
  const router = useRouter()
  const authStore = useAuthStore()
  const { closeMobileSidebar, menuItems } = useDefaultLayout()

  const selectedKeys = computed(() => route.name ? [String(route.name)] : [])
  const openKeys = computed(() => route.matched
    .slice(0, -1)
    .map(record => String(record.name))
    .filter(Boolean))

  const handleMenuClick = ({ key }: { key: string | number }) => {
    router.push({ name: String(key) })
    closeMobileSidebar()
  }

  const logout = () => {
    authStore.logout()
    router.push('/auth/login')
  }

  return {
    handleMenuClick,
    logout,
    menuItems,
    openKeys,
    selectedKeys,
    user: computed(() => authStore.user),
  }
}
